<!-- 
Menu allowing exporting of some levy collection records.

Clicking an export will trigger a download of the selected data in an Excel spreadsheet.
The exports are the same as those that can be triggered from the individual listings.
-->
<template>
  <v-menu v-model="menuOpen" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn :disabled="disabled" :block="xs" class="mb-3" v-on="on">
        <v-icon class="mr-2">get_app</v-icon>
        Export
        <our-expand-icon :expanded="menuOpen"/>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile 
        v-for="(excelExport, index) in excelExports" 
        :key="index" 
        @click.prevent="performExport(excelExport)"
      >
        <v-list-tile-title>{{ excelExport.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import taskMixins from "@/mixins/task.mixins";
import * as lcpAction from "@/store/levy-collection-providers/action-types";
import * as lcoAction from "@/store/levy-collection-overrides/action-types";
import * as noticesAction from "@/store/notices/action-types";
import * as invoicesAction from "@/store/invoices/action-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import * as lcoMutation from "@/store/levy-collection-overrides/mutation-types";
import * as noticesMutation from "@/store/notices/mutation-types";
import * as invoicesMutation from "@/store/invoices/mutation-types";

export default {
  mixins: [lookupMixins, taskMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuOpen: false
    };
  },
  computed: {
    excelExports() {
      return [
        {
          text: "Providers",
          action: lcpAction.EXPORT,
          clear: lcpMutation.LIST_CLEAR_CRITERIA,
          filter: lcpMutation.LIST_SET_FILTERS,
          unload: lcpMutation.STATE_UNLOAD_LISTING
        },
        {
          text: "Overrides",
          action: lcoAction.EXPORT,
          clear: null,
          filter: lcoMutation.LIST_SET_FILTERS,
          unload: lcoMutation.STATE_UNLOAD_LISTING
        },
        {
          text: "Notices",
          action: noticesAction.EXPORT,
          clear: noticesMutation.LIST_CLEAR_CRITERIA,
          filter: noticesMutation.LIST_SET_FILTERS,
          unload: noticesMutation.STATE_UNLOAD_LISTING
        },
        {
          text: "Invoices",
          action: invoicesAction.EXPORT,
          clear: invoicesMutation.LIST_CLEAR_CRITERIA,
          filter: invoicesMutation.LIST_SET_FILTERS,
          unload: invoicesMutation.STATE_UNLOAD_LISTING
        }
      ];
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  methods: {
    performExport(excelExport) {
      if (excelExport.clear) this.$store.commit(excelExport.clear);
      this.$store.commit(excelExport.filter, { levyCollectionId: this.levyCollectionId });
      this.$store.commit(excelExport.unload);
      this.$store.dispatch(excelExport.action);
    }
  }
};
</script>
